<div class="customer-details">
    <p class="header">{{'CUSTOMERS.CARD' | translate}}</p>
    <h3>{{'CUSTOMERS.CUSTOMER_DETAILS'|translate}}:</h3>
    <div>
        <div class="row-details row">
            <span class="title">{{'CUSTOMERS.NAME'|translate}}</span>
            <span class="value">{{ (lidDetails.FirstName || '') + ' ' + (lidDetails.LastName || '') }} </span>
        </div>
        <div class="row-details row">
            <span class="title">{{'CUSTOMERS.FIRST_WINS_CREATED_DATE'|translate}}</span>
            <span class="value">{{lidDetails.FirstWinCreatedDate | date:'dd/MM/yyyy'}}</span>
        </div>
        <div class="row-details row"><span class="title">{{'CUSTOMERS.PHONE'|translate}}</span>
            <span class="value">{{lidDetails.Phone}}</span>
        </div>
        <div class="row-details row"><span class="title">{{'CUSTOMERS.EMAIL'|translate}}</span>
            <span class="value">{{lidDetails.Email}}</span>
        </div>
        <div class="row-details row"><span class="title">{{'CUSTOMERS.ID'|translate}}</span>
            <span class="value">{{lidDetails.CustomerId}}</span>
        </div>
        <div *ngIf="lidDetails.CustomerAdditionalData?.length">
            <ng-container *ngFor="let data of lidDetails.CustomerAdditionalData">
                <div class="row-details row">
                    <span class="title">{{ data.Lable }}</span>
                    <ng-container [ngSwitch]="data.FieldType">
                        <ng-container *ngSwitchCase="2">
                            {{ (data.Value == 'true' || data.Value == true) ? ('CUSTOMERS.TRUE' | translate) :
                            ('CUSTOMERS.FALSE' | translate) }}
                        </ng-container>
                        <ng-container *ngSwitchCase="5">
                            <ng-container *ngIf="data.ArrayOptions">
                                {{ data.ArrayOptions.split(',')[+data.Value] }}
                            </ng-container>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ data.Value }}
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
    <h3>{{'CUSTOMERS.AWARDS'|translate}}:</h3>
</div>
<ng-template #actions let-rowData>
    <button *ngIf="rowData['Status']===statusType.notRealized" class="command-button full full-width"
        (click)="confirmUseWin(rowData['CouponNum'],rowData['CouponName'])">{{'CUSTOMERS.IMPLEMENT'|translate}}</button>
</ng-template>
<app-readonly-table class="dialog-table" #dt [columns]="couponsColumns" [selectionMode]="null" [itemsSource$]="coupons$"
    [isFilterable]="false" [isLoadLazy]="true" [paginator]="false">
</app-readonly-table>